import React, { Component } from 'react';
/*import { connect } from 'react-redux';*/
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import IconIndicator from '../Helpers/IconIndicator.jsx';
import LazyImg from '../Helpers/LazyImg';
import 'moment/locale/ru';

class BlogItem extends Component {
  render() {
    if(this.props.dummy) {
      return (
        <div className="cell mbottom20 bg-w3-op80 rad5 pr" style={{height:107}}>
        </div>
      );
    }
    return (
      <div className="cell boxShadow solid1 bo-w2 mbottom20 bg-w1 pr">
        <div className="up12 margin">
          <div className="cell s-shrink m-shrink h-shrink">
            <LazyImg src={`/autoresize/100x100xC${this.props.property_POST_AVATAR}`} alt={this.props.name} />
          </div>
          <div className="cell s-auto m-auto h-auto">
            <div className="fs18 font1 b1 ptop10">
                {this.props.name}
            </div>
            <div className="ptop10">
              <Moment locale="ru" format="ll">{this.props.created_time}</Moment>
            </div>
            <div className="ptop10 pbottom10 pright10">
              <IconIndicator className="" icon="thumb-up-outline" integer={this.props.rating_mark} />
              <IconIndicator className="pleft20" icon="eye">{this.props.view_unique?this.props.view_unique:0}</IconIndicator>
              <IconIndicator className="pleft20" icon="eye-outline">{this.props.view_all?this.props.view_all:0}</IconIndicator>
              <IconIndicator className="pleft20" icon="comment-outline">{this.props.c_comments_value?this.props.c_comments_value:0}</IconIndicator>
            </div>
          </div>
        </div>

        <Link className="clear b1 tdni pa pa-tl w100 h100" to={`/blog/${this.props.id}`}></Link>
      </div>
    )
  }
}


export default BlogItem;